<template>
  <el-row>
    <el-col :span="8">
      <el-menu
        mode="horizontal"
        class="navbar"
        :background-color="cssStyle.backgroundColor"
        :text-color="cssStyle.textColor"
        :active-text-color="cssStyle.activeTextColor"
      >
        <el-menu-item @click="goTo(navbar.logo.path)">
          <img :src="navbar.logo.src" />
        </el-menu-item>
      </el-menu>
    </el-col>

    <el-col :span="16">
      <el-menu
        mode="horizontal"
        class="navbarAction"
        :background-color="cssStyle.backgroundColor"
        :text-color="cssStyle.textColor"
        :active-text-color="cssStyle.activeTextColor"
      >
        <el-menu-item
          style="padding: 0 !important; margin-right: 15px !important"
          @click="emitSearchBarActiveHasChange"
        >
          <el-image
            class="image__search"
            :src="images.search.src"
            :fit="'contain'"
          />
        </el-menu-item>

        <el-menu-item
          style="padding: 0 !important; margin-right: 26px !important"
          @click="goTo('/shopping-cart')"
        >
          <div
            v-if="!isShoppingCartEmpty"
            class="shopping-cart__items__indicator"
          />
          <el-image
            class="image__cart"
            :src="images.cart.src"
            :fit="'contain'"
          />
        </el-menu-item>

        <el-menu-item
          style="padding: 0 !important; margin-right: 0 !important"
          @click="openNavbar"
        >
          <el-image
            class="image__hamburger"
            :src="images.hamburger.src"
            :fit="'contain'"
          />
        </el-menu-item>
      </el-menu>
    </el-col>

    <el-drawer
      :visible.sync="showNavbar"
      :size="drawer.size"
      :with-header="false"
    >
      <Scrollable>
        <div class="navbarMenu">
          <div
            v-for="(menu, i) in navbar.menus"
            :key="i"
            class="subtitle1"
            @click="
              openNavbarActiveSubMenu(
                menu,
                navbarActiveSubMenu.typeValues.NAVBAR_MENUS
              )
            "
          >
            <div @click="goTo(menu.path, isEmpty(menu.subMenuGroups))">
              <el-col :span="21">
                {{ menu.name }}
              </el-col>

              <el-col :span="3">
                <i
                  v-if="!isEmpty(menu.subMenuGroups)"
                  class="el-icon-arrow-right"
                />
              </el-col>
            </div>
          </div>
        </div>

        <div class="navbarUserMenu">
          <div class="subtitle1">
            <!-- TODO: Remove the hardcoded value -->
            <div @click="goTo('/account')">
              <el-col>
                <span>{{ $i18n.t("users.account.title") }}</span>
              </el-col>
            </div>
          </div>
        </div>

        <div class="navbarActionBar">
          <div
            v-for="(actionBar, i) in navbar.actionBar"
            :key="i"
            class="subtitle1"
            @click="
              openNavbarActiveSubMenu(
                actionBar,
                navbarActiveSubMenu.typeValues.ACTION_BAR_ITEMS
              )
            "
          >
            <div>
              <el-col :span="21">
                {{ actionBar.label }} ({{ getActionBarValue(actionBar.type) }})
              </el-col>

              <el-col :span="3">
                <i class="el-icon-arrow-right" />
              </el-col>
            </div>
          </div>
        </div>
      </Scrollable>
    </el-drawer>

    <el-drawer
      :visible.sync="showNavbarActiveSubMenu"
      :size="drawer.size"
      :with-header="false"
    >
      <div class="navbarSubMenuHeader button" @click="openNavbar">
        <i class="el-icon-arrow-left" />
        {{ drawer.previousBtnName }}
      </div>

      <Scrollable>
        <div
          v-for="(subMenuGroup, i) in navbarActiveSubMenu.subMenuGroups"
          :key="i"
        >
          <div>
            <h5
              :style="{
                borderColor:
                  cssStyle.subMenuGroupColors[i] ||
                  head(cssStyle.subMenuGroupColors),
              }"
            >
              {{ subMenuGroup.title }}
            </h5>
          </div>

          <div class="navbarSubMenuGroup">
            <template v-for="(item, j) in subMenuGroup.items">
              <div
                v-if="
                  navbarActiveSubMenu.type ===
                  navbarActiveSubMenu.typeValues.NAVBAR_MENUS
                "
                :key="j"
                class="navbarSubMenuItem button"
                :style="{
                  color:
                    cssStyle.subMenuGroupColors[i] ||
                    head(cssStyle.subMenuGroupColors),
                }"
                @click="goTo(item.path)"
              >
                {{ item.name }}
              </div>

              <div
                v-else-if="
                  navbarActiveSubMenu.type ===
                  navbarActiveSubMenu.typeValues.ACTION_BAR_ITEMS
                "
                :key="j"
                class="navbarSubMenuItem button"
                :style="{
                  color:
                    cssStyle.subMenuGroupColors[i] ||
                    head(cssStyle.subMenuGroupColors),
                }"
                @click="
                  emitActionBarValueHasChange(
                    item,
                    navbarActiveSubMenu.itemType
                  )
                "
              >
                <el-col :span="21">
                  {{ item.displayLabel }}
                </el-col>

                <el-col :span="3">
                  <i v-if="isSelectedActionValue(item)" class="el-icon-check" />
                </el-col>
              </div>
            </template>
          </div>
        </div>
      </Scrollable>
    </el-drawer>
  </el-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { head, isEmpty, keyBy, toLower } from "@/utils/lodash";

import imgSearch from "@/assets/images/navbar/navbar-search.png";
import imgCart from "@/assets/images/navbar/navbar-cart.svg";
import imgHamburger from "@/assets/images/navbar/navbar-hamburger.png";

import Scrollable from "@/components/scrollable.vue";
import Store from '@/store';

// import goTo from "../../mixins/goTo";

export default {
  // mixins: [goTo],
  components: {
    Scrollable,
  },
  props: {
    navbar: {
      type: Object,
      default: () => {},
    },
    selectedActionValues: {
      type: Object,
      default: () => {},
    },
    cssStyle: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showNavbar: false,
      showNavbarActiveSubMenu: false,
      navbarActiveSubMenu: {
        typeValues: {
          NAVBAR_MENUS: "NAVBAR_MENUS",
          ACTION_BAR_ITEMS: "ACTION_BAR_ITEMS",
        },
        type: null,
        itemType: null,
        subMenuGroups: [],
      },
      drawer: {
        size: "60%",
        previousBtnName: this.$i18n.t("common.navbar.previousBtnName"),
      },
      images: {
        search: {
          src: imgSearch,
        },
        cart: {
          src: imgCart,
        },
        hamburger: {
          src: imgHamburger,
        },
      },
    };
  },
  computed: {
    ...mapGetters("shoppingCart", ["isShoppingCartEmpty"]),
    ...mapGetters("user", ["isLoggedIn"]),

  },
  methods: {
    ...mapActions("user", ["logout"]),
    goTo (path, condition = true) {
      const getCountryCode = localStorage.getItem('actualCountryCode');
      if(this.isLoggedIn == true && getCountryCode == 'QC' && path == '/products??inventory=STORE_TORONTO') {
        this.handleLogout();
        return;
      }
      if (this.isLoggedIn == true && getCountryCode == 'ON' && path == '/products??inventory=STORE_MTL') {
        this.handleLogout();
        return;
      }
      if (condition) {
        this.$router.push(path).then(() => {});
      }
    },
    isEmpty(array) {
      return isEmpty(array);
    },
    head(array) {
      return head(array);
    },
    openNavbar() {
      this.closeNavbarActiveSubMenu();
      this.showNavbar = !this.showNavbar;
    },
    closeNavbar() {
      this.showNavbar = false;
    },
    openNavbarActiveSubMenu(menu, type) {
      if (!isEmpty(menu.subMenuGroups)) {
        this.closeNavbar();
        this.navbarActiveSubMenu.type = type;
        this.navbarActiveSubMenu.itemType = menu.type;
        this.navbarActiveSubMenu.subMenuGroups = menu.subMenuGroups;
        this.showNavbarActiveSubMenu = !this.showNavbarActiveSubMenu;
      }
    },
    closeNavbarActiveSubMenu() {
      this.navbarActiveSubMenu.type = null;
      this.navbarActiveSubMenu.itemType = null;
      this.navbarActiveSubMenu.subMenuGroups = [];
      this.showNavbarActiveSubMenu = false;
    },
    getActionBarValue(type) {
      const toLowerType = toLower(type);
      const indexActionBarTypeItemsByCode = keyBy(
        head(
          this.$i18n.t(`common.navbar.actionBar.${toLowerType}.subMenuGroups`)
        ).items,
        "code"
      );

      return indexActionBarTypeItemsByCode[
        this.selectedActionValues[toLowerType]
      ].displayCode;
    },
    isSelectedActionValue(action) {
      return (
        action.code ===
        this.selectedActionValues[toLower(this.navbarActiveSubMenu.itemType)]
      );
    },
    emitActionBarValueHasChange(value, type) {
      this.closeNavbarActiveSubMenu();
      this.$emit("action-bar-value-has-change", {
        value,
        type,
      });
    },
    emitSearchBarActiveHasChange() {
      this.$emit("search-bar-active-has-change");
    },
    handleLogout() {
      Store.dispatch('user/logout');
      Store.dispatch('shoppingCart/emptyShoppingCart');
      Store.dispatch('user/createTempUser');
      
      this.logout();
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables.scss";

img {
  width: 92px;
  height: 29px;
}

i {
  color: $color-on-primary;
}

.navbarAction {
  float: right;
}
.el-drawer {
  & div {
    text-align: left;
    padding: 10px 5px;
  }

  & h5 {
    cursor: default;
    color: $color-on-background;
    display: inline-block;
    text-decoration: none;
    border-bottom: 2px solid;
    margin-bottom: -1px;
  }

  // & div {
  //   cursor: pointer;
  // }

  & i,
  & .navbarMenu,
  & .navbarUserMenu,
  & .navbarSubMenuHeader {
    color: $color-primary;
  }

  & .navbarUserMenu,
  & .navbarActionBar {
    padding-top: 10px;
  }

  & .navbarActionBar {
    color: $color-on-background-area1;

    & i {
      color: $color-on-background-area1;
    }
  }
}
.shopping-cart__items__indicator {
  width: 8px;
  height: 8px;
  background-color: #70b603;
  border-radius: 20px;
  position: absolute;
  top: 14px;
  z-index: 1000;
  left: 16px;
}
.el-drawer__body {
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
}
.image__search {
  width: 17px;
  height: 17px;
}
.image__cart {
  width: 20px;
  height: 17px;
}
.image__hamburger {
  width: 21px;
  height: 21px;
}
</style>
